import { omit, last } from 'lodash'
import { parseFullName } from 'parse-full-name'
import ActionType from '../../actions/ActionType'
import labelMap from '../../components/AddOrEditContactPage/labelMap'
import colors from '../../utils/colors'

// for some reason this doesn't work for clearing the email & phone fields
// when receiving null. might have to do with object depth

export default (
  state = {
    notes: { color: null, value: '', initialValue: '', error: {} },
    first_name: { color: null, value: '', initialValue: '', error: {} },
    last_name: { color: null, value: '', initialValue: '', error: {} },
    middle_name: { color: null, value: '', initialValue: '', error: {} },
    phones: [{ color: null, value: '', initialValue: '', opt_in: true }],
    email: [{ color: null, value: '', initialValue: '', opt_in: true }],
    location: { color: null, value: '', initialValue: '', error: {} },
    custom_attributes: {},
    phonesError: {},
    emailError: {},
    custom_attributesError: {},
  },
  action,
) => {
  switch (action.type) {
    // TODO: investigate why there's an update request in inbox
    case ActionType.Inbox.SELECT_CONTACT:
      if (!action.payload) {
        // returning the full object instead of initial state to make sure
        // phone and email fields clear on receiving a null payload
        return {
          notes: { color: null, value: '', initialValue: '', error: {} },
          first_name: { color: null, value: '', initialValue: '', error: {} },
          last_name: { color: null, value: '', initialValue: '', error: {} },
          middle_name: { color: null, value: '', initialValue: '', error: {} },
          phones: [{ color: null, value: '', initialValue: '', opt_in: true }],
          email: [{ color: null, value: '', initialValue: '', opt_in: true }],
          location: { color: null, value: '', initialValue: '', error: {} },
          custom_attributes: {},
          phonesError: {},
          emailError: {},
          custom_attributesError: {},
        }
      }
      const payloadWithColors = {}
      Object.keys(action.payload).forEach((key) => {
        if (key === 'custom_attributes') {
          payloadWithColors.custom_attributes = {}
          Object.keys(action.payload.custom_attributes).forEach(
            (customAttributeKey) => {
              payloadWithColors.custom_attributes[customAttributeKey] = {
                color: null,
                value: action.payload.custom_attributes[customAttributeKey],
                initialValue:
                  action.payload.custom_attributes[customAttributeKey],
                // hovered: false,
              }
            },
          )
        } else if (key === 'email') {
          payloadWithColors.email = action.payload.email.map((el) => ({
            color: null,
            // hovered: false,
            value: el.address,
            initialValue: el.address,
            email_type: el.email_type,
            opt_in: el.opt_in,
            id: el.id,
          }))
        } else if (key === 'phones') {
          payloadWithColors.phones = action.payload.phones.map((el) => ({
            color: null,
            // hovered: false,
            value: el.number.slice(2),
            initialValue: el.number,
            ...el,
          }))
        } else if (key === 'phone' || key === 'contact_groups') {
          return
        } else {
          payloadWithColors[key] = {
            color: null,
            value: action.payload[key],
            initialValue: action.payload[key],
            error: {},
          }
        }
      })
      return {
        notes: { color: null, value: '', initialValue: '', error: {} },
        first_name: { color: null, value: '', initialValue: '', error: {} },
        last_name: { color: null, value: '', initialValue: '', error: {} },
        middle_name: { color: null, value: '', initialValue: '', error: {} },
        phones: [{ color: null, value: '', initialValue: '', opt_in: true }],
        email: [{ color: null, value: '', initialValue: '', opt_in: true }],
        location: { color: null, value: '', initialValue: '', error: {} },
        custom_attributes: {},
        phonesError: {},
        emailError: {},
        custom_attributesError: {},
        ...payloadWithColors,
      }
    case ActionType.Contacts.VALIDATION_SUCCESS:
      return {
        ...state,
        notes: { ...state.notes, error: {} },
        first_name: { ...state.first_name, error: {} },
        last_name: { ...state.last_name, error: {} },
        middle_name: { ...state.middle_name, error: {} },
        location: { ...state.location, error: {} },
        phonesError: {},
        emailError: {},
        custom_attributesError: {},
      }
    case ActionType.Contacts.VALIDATION_FAILURE:
      const dup = state
      const pathStateMap = {
        '.first_name': 'first_name',
        '.middle_name': 'middle_name',
        '.last_name': 'last_name',
        '.location': 'location',
        '.notes': 'notes',
      }

      action.errors.forEach((error, idx) => {
        if (
          error.dataPath &&
          pathStateMap[error.dataPath] &&
          dup[pathStateMap[error.dataPath]]
        ) {
          dup[pathStateMap[error.dataPath]].error = {
            ...dup[pathStateMap[error.dataPath]].error,
            [error.message]: error,
          }
          // if (dup[pathStateMap[error.dataPath]].error) {
          //   dup[pathStateMap[error.dataPath]].error = `${
          //     dup[pathStateMap[error.dataPath]].error
          //   }, ${error.message}`
          // } else {
          //   dup[pathStateMap[error.dataPath]].error = error.message
          // }
        }

        if (error.dataPath.slice(0, 6) === '.email') {
          dup.emailError = {
            ...dup.emailError,
            [error.message]: error,
          }
          // if (dup.email.error) {
          //   dup.emailError = `${dup.email.error}, ${error.message}`
          // } else {
          //   dup.emailError = error.message
          // }
        }

        if (error.dataPath.slice(0, 7) === '.phones') {
          dup.phonesError = {
            ...dup.phonesError,
            [error.message]: error,
          }
          // if (dup.phones.error) {
          //   dup.phonesError = `${dup.phones.error}, ${error.message}`
          // } else {
          //   dup.phonesError = error.message
          // }
        }

        if (error.dataPath.slice(0, 18) === '.custom_attributes') {
          dup.emailError = {
            ...dup.custom_attributesError,
            [error.message]: error,
          }
          // if (dup.custom_attributes.error) {
          //   dup.custom_attributesError = `${dup.custom_attributes.error}, ${error.message}`
          // } else {
          //   dup.custom_attributesError = error.message
          // }
        }
      })

      return dup
    case ActionType.Contacts.HANDLE_DEFAULT_FIELD_CHANGE:
      return {
        ...state,
        [action.payload.name]: {
          ...(state?.[action.payload.name] || {}),
          value: action.payload.value,
        },
      }
    case ActionType.Contacts.HANDLE_CUSTOM_ATTRIBUTE_CHANGE:
      return {
        ...state,
        custom_attributes: {
          ...state.custom_attributes,
          [action.payload.name]: {
            ...state.custom_attributes[action.payload.name],
            value: { [action.payload.type]: action.payload.value },
          },
        },
      }
    case ActionType.Contacts.HANDLE_FIELD_CHANGE:
      const newState = state[action.payload.fieldType]
      newState[action.payload.index].value = action.payload.value
      return {
        ...state,
        [action.payload.fieldType]: newState,
      }
    case ActionType.Contacts.HANDLE_ADD_FIELD:
      if (last(state[action.payload]).value.length) {
        return {
          ...state,
          [action.payload]: [
            ...state[action.payload],
            { opt_in: true, color: null, value: '', initialValue: '' },
          ],
        }
      }
      return state
    case ActionType.Contacts.ADD_CUSTOM_FIELDS:
      return {
        ...state,
        custom_attributes: {
          ...state.custom_attributes,
          ...action.payload,
        },
      }
    case ActionType.Contacts.RECEIVE_CONTACT:
      if (!action.payload) {
        // returning the full object instead of initial state to make sure
        // phone and email fields clear on receiving a null payload
        return {
          notes: { color: null, value: '', initialValue: '', error: {} },
          first_name: { color: null, value: '', initialValue: '', error: {} },
          last_name: { color: null, value: '', initialValue: '', error: {} },
          middle_name: { color: null, value: '', initialValue: '', error: {} },
          phones: [{ color: null, value: '', initialValue: '', opt_in: true }],
          email: [{ color: null, value: '', initialValue: '', opt_in: true }],
          location: { color: null, value: '', initialValue: '', error: {} },
          custom_attributes: {},
          phonesError: {},
          emailError: {},
          custom_attributesError: {},
        }
      }
      const payloadWithColors2 = {}
      Object.keys(action.payload).forEach((key) => {
        if (key === 'custom_attributes') {
          payloadWithColors2.custom_attributes = {}
          Object.keys(action.payload.custom_attributes).forEach(
            (customAttributeKey) => {
              payloadWithColors2.custom_attributes[customAttributeKey] = {
                color: null,
                value: action.payload.custom_attributes[customAttributeKey],
                initialValue:
                  action.payload.custom_attributes[customAttributeKey],
                // hovered: false,
              }
            },
          )
        } else if (key === 'email') {
          payloadWithColors2.email = action.payload.email.map((el) => ({
            color: null,
            // hovered: false,
            value: el.address,
            initialValue: el.address,
            email_type: el.email_type,
            opt_in: el.opt_in,
            id: el.id,
          }))
        } else if (key === 'phones') {
          payloadWithColors2.phones = action.payload.phones.map((el) => ({
            color: null,
            // hovered: false,
            value: el.number.slice(2),
            initialValue: el.number,
            ...el,
          }))
        } else if (key === 'phone' || key === 'contact_groups') {
          return
        } else {
          payloadWithColors2[key] = {
            color: null,
            value: action.payload[key],
            initialValue: action.payload[key],
            error: {},
          }
        }
      })

      return {
        notes: { color: null, value: '', initialValue: '', error: {} },
        first_name: { color: null, value: '', initialValue: '', error: {} },
        last_name: { color: null, value: '', initialValue: '', error: {} },
        middle_name: { color: null, value: '', initialValue: '', error: {} },
        phones: [{ color: null, value: '', initialValue: '', opt_in: true }],
        email: [{ color: null, value: '', initialValue: '', opt_in: true }],
        location: { color: null, value: '', initialValue: '', error: {} },
        custom_attributes: {},
        phonesError: {},
        emailError: {},
        custom_attributesError: {},
        ...payloadWithColors2,
      }
    case ActionType.Contacts.TOGGLE_OPT_OUT_SUCCESS:
      const type = action.methodType === 'email' ? 'email' : 'phones'
      const arr = state[type]
      arr[action.index].opt_in = !arr[action.index].opt_in
      return {
        ...state,
        [type]: arr,
      }
    case ActionType.Contacts.TOGGLE_CUSTOM_FIELD_HOVER:
      return {
        ...state,
        custom_attributes: {
          ...state.custom_attributes,
          [action.payload]: {
            ...state.custom_attributes[action.payload],
            hovered: !state.custom_attributes[action.payload].hovered,
          },
        },
      }
    case ActionType.Contacts.REMOVE_CUSTOM_ATTRIBUTE:
      return {
        ...state,
        custom_attributes: omit(state.custom_attributes, action.payload),
      }
    case ActionType.SmartNotes.GET_ENTITIES_SUCCESS:
      let newFirstName = state.first_name
      let newMiddleName = state.middle_name
      let newLastName = state.last_name
      let newLocation = state.location
      let newCustomAttributes = state.custom_attributes

      const findNextObjectKey = (text, potentialKey, obj, i = 0) => {
        if (obj[potentialKey]) {
          if (obj[potentialKey].value.S === text) {
            return false
          }
          return findNextObjectKey(text, `${potentialKey} ${i + 1}`, obj, i + 1)
        }
        return potentialKey
      }

      action.payload.Entities.forEach((entity, i) => {
        const color = colors[i % colors.length]
        if (entity.Type === 'PERSON') {
          const nameArr = entity.Text.split(' ')
          if (
            newFirstName.value === '' &&
            newMiddleName.value === '' &&
            newLastName.value === ''
          ) {
            newFirstName = { color, value: nameArr[0] }
            newMiddleName =
              nameArr.length > 2
                ? { color, value: nameArr.slice(1, -1) }
                : { color: null, value: '' }
            newLastName =
              nameArr.length > 1
                ? { color, value: nameArr[nameArr.length - 1] }
                : { color: null, value: '' }
          } else if (
            newFirstName.value === nameArr[0] &&
            (nameArr.length > 2
              ? newMiddleName.value === nameArr.slice(1, -1)
              : true) &&
            (nameArr.length > 1
              ? newLastName.value === nameArr[nameArr.length - 1]
              : true)
          ) {
            return
          } else {
            const validKey = findNextObjectKey(
              entity.Text,
              labelMap[entity.Type],
              newCustomAttributes,
            )

            if (validKey) {
              newCustomAttributes[validKey] = {
                color,
                value: { S: entity.Text },
                initialValue: { S: entity.Text },
              }
            }
          }
        } else if (entity.Type === 'LOCATION') {
          if (newLocation.value === '') {
            newLocation = { color, value: entity.Text }
          } else if (newLocation.value === entity.Text) {
            return
          } else {
            const validKey = findNextObjectKey(
              entity.Text,
              labelMap[entity.Type],
              newCustomAttributes,
            )

            if (validKey) {
              newCustomAttributes[validKey] = {
                color,
                value: { S: entity.Text },
                initialValue: { S: entity.Text },
              }
            }
          }
        } else {
          const validKey = findNextObjectKey(
            entity.Text,
            labelMap[entity.Type],
            newCustomAttributes,
          )

          if (validKey) {
            newCustomAttributes[validKey] = {
              color,
              value: { S: entity.Text },
              initialValue: { S: entity.Text },
            }
          }
        }
      })
      return {
        ...state,
        first_name: newFirstName,
        middle_name: newMiddleName,
        last_name: newLastName,
        location: newLocation,
        custom_attributes: newCustomAttributes,
      }
    case ActionType.Contacts.INGEST_PREDICTION:
      let newFName = state.first_name
      let newMName = state.middle_name
      let newLName = state.last_name
      let newLoc = state.location
      let newPhones = state.phones
      let newEmail = state.email
      let newCustAttr = state.custom_attributes

      const findNextObjKey = (text, potentialKey, obj, i = 0) => {
        if (obj[potentialKey]) {
          if (obj[potentialKey].value.S === text) {
            return false
          }
          return findNextObjKey(text, `${potentialKey} ${i + 1}`, obj, i + 1)
        }
        return potentialKey
      }

      action.payload.forEach((entity, i) => {
        if (entity.type === 'builtin.personName') {
          const name = parseFullName(entity.entity)
          if (
            newFName.value === '' &&
            newMName.value === '' &&
            newLName.value === ''
          ) {
            newFName = {
              color: null,
              value:
                name.first && name.last
                  ? name.first
                  : name.last
                  ? ''
                  : entity.entity,
              initialValue: '',
            }
            newMName = {
              color: null,
              value: name.middle ? name.middle : '',
              initialValue: '',
            }
            newLName = {
              color: null,
              value: name.last ? name.last : '',
              initialValue: '',
            }
          } else {
            const validKey = findNextObjKey(
              entity.entity,
              labelMap[entity.type],
              newCustAttr,
            )

            if (validKey) {
              newCustAttr[validKey] = {
                color: null,
                value: { S: entity.entity },
                initialValue: { S: entity.entity },
              }
            }
          }
        } else if (entity.type === 'LOCATION') {
          if (newLoc.value === '') {
            newLoc = { color: null, value: entity.entity, initialValue: '' }
          } else if (newLoc.value === entity.entity) {
            return
          } else {
            const validKey = findNextObjKey(
              entity.entity,
              labelMap[entity.type],
              newCustAttr,
            )

            if (validKey) {
              newCustAttr[validKey] = {
                color: null,
                value: { S: entity.entity },
                initialValue: { S: entity.entity },
              }
            }
          }
        } else if (entity.type === 'builtin.phonenumber') {
          if (newPhones[0].value === '') {
            newPhones[0].value = entity.entity
          } else {
            newPhones.push({
              color: null,
              value: entity.entity,
              initialValue: '',
            })
          }
        } else if (entity.type === 'builtin.email') {
          if (newEmail[0].value === '') {
            newEmail[0].value = entity.entity
          } else {
            newEmail.push({
              color: null,
              value: entity.entity,
              initialValue: '',
            })
          }
        } else {
          const validKey = findNextObjKey(
            entity.entity,
            labelMap[entity.type],
            newCustAttr,
          )

          if (validKey) {
            newCustAttr[validKey] = {
              color: null,
              value: { S: entity.entity },
              initialValue: { S: entity.entity },
            }
          }
        }
      })
      return {
        ...state,
        first_name: newFName,
        middle_name: newMName,
        last_name: newLName,
        location: newLoc,
        email: newEmail,
        phones: newPhones,
        custom_attributes: newCustAttr,
      }
    default:
      return state
  }
}
